<template>
    <div class="relative w-full h-full">
      <img :src="image" :alt="alt" class="w-full h-[600px] object-cover" />
      <div class="absolute inset-0 flex justify-center items-center bg-black/40">
        <h2 class="text-white text-3xl md:text-5xl lg:text-6xl font-bold text-center max-w-4xl px-6">
          {{ text }}
        </h2>
      </div>
    </div>
  </template>
  
  
  <script>
  export default {
    name: 'SlideComponent',
    props: {
      image: {
        type: String,
        required: true
      },
      alt: {
        type: String,
        default: 'Slide Image'
      },
      text: {
        type: String,
        required: true
      }
    }
  };
  </script>
  